const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRegion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M257.664,66.506C377.848,67.401,475,165.105,475,285.5v0c0,120.95-98.05,219-219,219h0c-120.95,0-219-98.05-219-219v0 c0-77.85,40.621-146.212,101.823-185.048"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M371.5,291.758L371.5,291.758c-9.983,0-46.909-40.463-46.909-69.607v0c0-25.907,21.002-46.909,46.909-46.909h0 c25.907,0,46.909,21.002,46.909,46.909v0C418.409,251.294,381.295,291.758,371.5,291.758z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M371.5,235.5L371.5,235.5c-8.284,0-15-6.716-15-15v0c0-8.284,6.716-15,15-15l0,0c8.284,0,15,6.716,15,15v0 C386.5,228.784,379.784,235.5,371.5,235.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M183.5,411.758L183.5,411.758c-9.983,0-46.909-40.463-46.909-69.607v0c0-25.907,21.002-46.909,46.909-46.909h0 c25.907,0,46.909,21.002,46.909,46.909v0C230.409,371.294,193.295,411.758,183.5,411.758z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M183.5,355.5L183.5,355.5c-8.284,0-15-6.716-15-15l0,0c0-8.284,6.716-15,15-15h0c8.284,0,15,6.716,15,15l0,0 C198.5,348.784,191.784,355.5,183.5,355.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M194.5,161.5L194.5,161.5c-13.194,0-62-53.481-62-92v0c0-34.242,27.758-62,62-62h0c34.242,0,62,27.758,62,62v0 C256.5,108.019,207.446,161.5,194.5,161.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M194.5,84.5L194.5,84.5c-8.284,0-15-6.716-15-15v0c0-8.284,6.716-15,15-15h0c8.284,0,15,6.716,15,15v0 C209.5,77.784,202.784,84.5,194.5,84.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M150,212.5h11c10.217,0,18.5,8.283,18.5,18.5v0c0,10.217,8.283,18.5,18.5,18.5h18c10.217,0,18.5-8.283,18.5-18.5v-37 c0-10.217,8.283-18.5,18.5-18.5h10c10.217,0,18.5-8.283,18.5-18.5v-9c0-10.217,8.283-18.5,18.5-18.5h9 c10.217,0,18.5-8.283,18.5-18.5V81.42"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M39.828,262.5H78c10.217,0,18.5-8.283,18.5-18.5v-13c0-10.217,8.283-18.5,18.5-18.5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M233.357,340.5H248.5c11.046,0,20,8.954,20,20v45.567c0,6.788,3.443,13.113,9.145,16.798l14.71,9.506 c5.702,3.684,9.145,10.009,9.145,16.798V499.5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M60.924,380.5H83.5c11.046,0,20-8.954,20-20v0c0-11.046,8.954-20,20-20h10.799"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 420.465,
    y1: 224.5,
    x2: 464.108,
    y2: 224.5
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M372.854,394.5H363c-10.217,0-18.5-8.283-18.5-18.5v-25.067c0-10.183-8.23-18.452-18.413-18.5l-16.175-0.076 c-10.183-0.048-18.413-8.317-18.413-18.5V280c0-10.217,8.283-18.5,18.5-18.5h26c0.812,0,1.612-0.052,2.396-0.154"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 442.834,
    y1: 394.5,
    x2: 407.854,
    y2: 394.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegion);
export default __webpack_public_path__ + "static/media/region.9a00e60658fe28a992104c87ce647a66.svg";
export { ForwardRef as ReactComponent };